import { isB2B } from '@/core/settings/utils';
import { Swap } from '@/core/tamagoshi/icons/Swap';
import { useSellerReturnPolicy } from '@/domains/care/returns/hooks/useSellerReturnPolicy';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Bullet } from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/Bullet';
import {
  FulfillmentContent,
  FulfillmentHeader,
  pFormat,
  useFlagsByPlatform,
} from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/GoodToKnowUtils';
import {
  B2BFreeReturnsModalContent,
  B2BFreeReturnsModalTitle,
  returnPolicyWhenFree,
  returnPolicyWhenFree100days,
  returnPolicyWhenFreeNoDays,
  returnPolicyWhenNotFree,
} from '@/productDiscovery/ProductPage/common/modules/GoodToKnow/translations';
import { MF_100_DAYS_FREE_RETURNS_FLAG } from '@/productDiscovery/ProductPage/constants';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

export const ReturnPolicyBullet = () => {
  const { delivery, seller } = useDetail();
  const sellerReturnPolicy = useSellerReturnPolicy({
    sellerId: seller.id,
    withText: false,
  });

  const b2bReturnsFlag = useFlagsByPlatform({
    it: 'freeReturnItB2B',
    de: 'freeReturnDeB2B',
    fr: 'freeReturnFrB2B',
  });
  const [is100DaysReturn] = useBooleanFlags([MF_100_DAYS_FREE_RETURNS_FLAG]);

  if (!sellerReturnPolicy) return null;

  const { returnFeesFree, returnWithdrawalLimitInDays } = sellerReturnPolicy;

  if (delivery?.fulfillment && is100DaysReturn) {
    return (
      <Bullet
        icon={<Swap />}
        modalContent={<FulfillmentContent />}
        modalHeader={<FulfillmentHeader />}
      >
        {returnPolicyWhenFree100days}
      </Bullet>
    );
  }

  if (b2bReturnsFlag && isB2B()) {
    return (
      <Bullet
        icon={<Swap />}
        modalContent={B2BFreeReturnsModalContent.format({
          withdrawalDays: returnWithdrawalLimitInDays ?? 14,
          reimbursementDays: 14,
          strong: (chunk) => <b>{chunk}</b>,
          br: pFormat,
        })}
        modalHeader={B2BFreeReturnsModalTitle}
      >
        {returnWithdrawalLimitInDays
          ? returnPolicyWhenFree.format({
              days: returnWithdrawalLimitInDays,
            })
          : returnPolicyWhenFreeNoDays}
      </Bullet>
    );
  }

  return (
    <Bullet icon={<Swap />}>
      {(returnFeesFree ? returnPolicyWhenFree : returnPolicyWhenNotFree).format(
        {
          days: returnWithdrawalLimitInDays || 0,
        },
      )}
    </Bullet>
  );
};
